/**
 * セミナー参加形態 種類 1:オンライン
 */
export const SEMINAR_PARTICIPATION_TYPE_TYPE_ONLINE = {
    label: 'オンライン',
    value: 1,
};
/**
 * セミナー参加形態 種類 2:対面
 */
export const SEMINAR_PARTICIPATION_TYPE_TYPE_FACE_TO_FACE = {
    label: '対面',
    value: 2,
};
/**
 * セミナー参加形態 種類
 */
export const SEMINAR_PARTICIPATION_TYPE_TYPES = [
    SEMINAR_PARTICIPATION_TYPE_TYPE_ONLINE,
    SEMINAR_PARTICIPATION_TYPE_TYPE_FACE_TO_FACE,
];
